import React, { useEffect } from 'react';
import './ProgressBar.css';
import useStorage from '../../hooks/useStorage';
import {motion} from 'framer-motion';

const ProgressBar = ({file, setFile}) => {
    const {progress, url} = useStorage(file);

    useEffect(()=>{
        if(url){
            setFile(null);
        }
    },[url,setFile]);

    return(
        <div className="progress-wrapper">
            <div>{file.name}</div>
            <motion.div 
                className="progress-bar"
                initial={{width:0}}
                animate={{width: progress + '%'}}
            >
            </motion.div>
        </div>
    )
}

export default ProgressBar;